import { styled } from '@mui/material/styles';

export const TooltipChildWrapper = styled('span')`
  display: flex;
  flex: 1;
`;
